import lodash from 'lodash';
import { action, observable } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics, Utils } from '../../helpers';
import { BasesController } from '../bases';
export class PriceQuotationDetailController extends BasesController<any> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      details: EnumAPI.business_priceQuotationDetail,
      detailsParams: {
        // valueGetter: this.valueGetter,
      },
    });
  }
  /**
   * @des 订单编号
   */
  @observable
  orderNumber = '';

  /**
   * @des 订单列表
   */
  @observable
  orderList = [{ productInfo: [] }];

  @action.bound
  setOrderList(val) {
    this.orderList = val;
  }

  @action.bound
  setOrderNumber(val) {
    this.orderNumber = val;
  }

  valueGetter = async (response, AjaxConfig) => {
    const {
      opportunityBusiness,
      customerInfo,
      customerInfo: { provinceName, cityName },
      opportunityBusiness: {
        status,
        preStatus,
        reportProvinceName,
        reportCityName,
      },
      productList,
      providerName,
      providerCode,
    } = response;
    this.setOrderList([{ productInfo: [] }]);

    lodash.assign(response, {
      _busInfo: lodash.assign({}, customerInfo, opportunityBusiness, {
        //当商机状态status为8时，说明是待审核状态，应取preStatus
        curStatus: status != 8 ? status : preStatus,
        _status:
          status != 8
            ? lodash.get(this.statusEnum, status)
            : lodash.get(this.statusEnum, preStatus),
        _budget: opportunityBusiness.budget
          ? Utils.currency(opportunityBusiness.budget)
          : '',
        addressName: opportunityBusiness
          ? `${reportProvinceName}${reportCityName}`
          : '',
        providerName,
        providerCode,
        cAddressName: customerInfo ? `${provinceName}${cityName}` : '',
      }),
      _productList: productList,
    });
    return response;
  };
  /**
   * @des 状态枚举
   */
  statusEnum = {
    '0': '草稿',
    '1': '已提交',
    '2': '跟进中',
    '3': '持续跟进',
    '4': '已关闭',
    '5': '已提交bidding',
    '6': '已生成报价单',
    '7': '已转订单',
  };

  /**
   * @des 订单详情列表
   */
  async onBusinessFindOrderDetail(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_findOrderDetail,
      body,
    });
  }

  /**
   * @description: 跳转转单前修改产品数量
   * @param {*} Entity
   * @return {*}
   */
  async onUpdateProductNumber(Entity) {
    return await AjaxBasics.request(
      lodash.assign({}, EnumAPI.business_priceQuotation_updateProductNumber, {
        body: Entity,
      }),
    );
  }

  /**
   * @description: 拒绝转单
   * @param {*} Entity
   * @return {*}
   */
  async onRefuseQuotation(Entity) {
    return await AjaxBasics.request(
      lodash.assign({}, EnumAPI.business_priceQuotation_refuse, {
        body: Entity,
      }),
    );
  }
}
